import useCodatIntegration from './useCodatIntegration';

const useDynamics365 = () => {
  const {
    onImportData: onImportDynamics365Data,
    isLoading: isLoadingDynamics365sData,
    isIntegrated: isIntegratedWithDynamics365,
    onLogin: onQuickBooksLogin,
    isImporting: isImportingDynamics365Data,
    queueNewCodatSync: queueNewDynamics365Sync,
    syncStatus: quickBooksSyncStatus,
  } = useCodatIntegration({
    platformNames: ['Dynamics 365 Business Central'],
  });

  return {
    isImportingDynamics365Data,
    isIntegratedWithDynamics365,
    isLoadingDynamics365sData,
    onImportDynamics365Data,
    onQuickBooksLogin,
    queueNewDynamics365Sync,
    quickBooksSyncStatus,
  };
};

export default useDynamics365;
